export const navigationDe = {
  breadcrumb: 'Navigationspfad',
  crm: 'CRM',
  salesOrderProcessing: 'Verkauf & Auftragsabwicklung',
  quotes: 'Angebote',
  salesOrders: 'Aufträge',
  deliveryNotes: 'Lieferscheine',
  invoices: 'Rechnungen',
  creditNotes: 'Gutschriften',
  allTransactions: 'Alle Vorgänge',
  productsInventory: 'Artikel & Lager',
  productionProductDevelopment: 'Produktion & Produktentwicklung',
  finance: 'Finanzen',
  bankAccounts: 'Bankkonten',
  bankTransactions: 'Banktransaktionen',
  bankReconciliation: 'Bankabgleich',
  payments: 'Zahlungszuordnungen',
  openItems: 'Offene Posten',
  dunning: 'Mahnwesen',
  communicationDocuments: 'Kommunikation & Dokumente',
  marketing: 'Marketing',
  newsletterOverview: 'Übersicht',
  newsletterCampaigns: 'Kampagnen',
  newsletterTemplates: 'Vorlagen',
  newsletterAudiences: 'Zielgruppen',
  newsletterImports: 'Empfängerimport',
  newsletterRecipients: 'Empfänger',
  newsletterConsents: 'Einwilligungen',
  newsletterExistingCustomer: 'Bestandskundenprüfung',
  newsletterSuppression: 'Sperrliste',
  newsletterDeliverability: 'Zustellbarkeit',
  newsletterAnalytics: 'Auswertungen',
  newsletterSettings: 'Einstellungen',
  administration: 'Administration',
} as const;

export const navigationEn = {
  breadcrumb: 'Breadcrumb',
  crm: 'CRM',
  salesOrderProcessing: 'Sales & order processing',
  quotes: 'Quotations',
  salesOrders: 'Sales orders',
  deliveryNotes: 'Delivery notes',
  invoices: 'Invoices',
  creditNotes: 'Credit notes',
  allTransactions: 'All transactions',
  productsInventory: 'Products & inventory',
  productionProductDevelopment: 'Manufacturing & product development',
  finance: 'Finance',
  bankAccounts: 'Bank accounts',
  bankTransactions: 'Bank transactions',
  bankReconciliation: 'Bank reconciliation',
  payments: 'Payment allocations',
  openItems: 'Open items',
  dunning: 'Dunning management',
  communicationDocuments: 'Communication & documents',
  marketing: 'Marketing',
  newsletterOverview: 'Overview',
  newsletterCampaigns: 'Campaigns',
  newsletterTemplates: 'Templates',
  newsletterAudiences: 'Audiences',
  newsletterImports: 'Recipient import',
  newsletterRecipients: 'Recipients',
  newsletterConsents: 'Consents',
  newsletterExistingCustomer: 'Existing-customer review',
  newsletterSuppression: 'Suppression list',
  newsletterDeliverability: 'Deliverability',
  newsletterAnalytics: 'Analytics',
  newsletterSettings: 'Settings',
  administration: 'Administration',
} as const;

export const navigationTr = {
  breadcrumb: 'Gezinti yolu',
  crm: 'CRM',
  salesOrderProcessing: 'Satış ve sipariş yönetimi',
  quotes: 'Teklifler',
  salesOrders: 'Satış siparişleri',
  deliveryNotes: 'İrsaliyeler',
  invoices: 'Faturalar',
  creditNotes: 'Alacak dekontları',
  allTransactions: 'Tüm işlemler',
  productsInventory: 'Ürünler ve stok',
  productionProductDevelopment: 'Üretim ve ürün geliştirme',
  finance: 'Finans',
  bankAccounts: 'Banka hesapları',
  bankTransactions: 'Banka işlemleri',
  bankReconciliation: 'Banka mutabakatı',
  payments: 'Ödeme eşleştirmeleri',
  openItems: 'Açık kalemler',
  dunning: 'Ödeme hatırlatmaları',
  communicationDocuments: 'İletişim ve belgeler',
  marketing: 'Pazarlama',
  newsletterOverview: 'Genel bakış',
  newsletterCampaigns: 'Kampanyalar',
  newsletterTemplates: 'Şablonlar',
  newsletterAudiences: 'Hedef kitleler',
  newsletterImports: 'Alıcı içe aktarma',
  newsletterRecipients: 'Alıcılar',
  newsletterConsents: 'Rızalar',
  newsletterExistingCustomer: 'Mevcut müşteri incelemesi',
  newsletterSuppression: 'Engelleme listesi',
  newsletterDeliverability: 'Teslim edilebilirlik',
  newsletterAnalytics: 'Analizler',
  newsletterSettings: 'Ayarlar',
  administration: 'Yönetim',
} as const;

export const navigationFr = {
  breadcrumb: 'Fil d’Ariane',
  crm: 'CRM',
  salesOrderProcessing: 'Ventes et traitement des commandes',
  quotes: 'Devis',
  salesOrders: 'Commandes clients',
  deliveryNotes: 'Bons de livraison',
  invoices: 'Factures',
  creditNotes: 'Avoirs',
  allTransactions: 'Toutes les opérations',
  productsInventory: 'Articles et stocks',
  productionProductDevelopment: 'Production et développement produit',
  finance: 'Finances',
  bankAccounts: 'Comptes bancaires',
  bankTransactions: 'Transactions bancaires',
  bankReconciliation: 'Rapprochement bancaire',
  payments: 'Affectations de paiements',
  openItems: 'Postes ouverts',
  dunning: 'Relances',
  communicationDocuments: 'Communication et documents',
  marketing: 'Marketing',
  newsletterOverview: 'Vue d’ensemble',
  newsletterCampaigns: 'Campagnes',
  newsletterTemplates: 'Modèles',
  newsletterAudiences: 'Audiences',
  newsletterImports: 'Import de destinataires',
  newsletterRecipients: 'Destinataires',
  newsletterConsents: 'Consentements',
  newsletterExistingCustomer: 'Examen client existant',
  newsletterSuppression: 'Liste d’exclusion',
  newsletterDeliverability: 'Délivrabilité',
  newsletterAnalytics: 'Analyses',
  newsletterSettings: 'Paramètres',
  administration: 'Administration',
} as const;

export const navigationEs = {
  breadcrumb: 'Ruta de navegación',
  crm: 'CRM',
  salesOrderProcessing: 'Ventas y gestión de pedidos',
  quotes: 'Ofertas',
  salesOrders: 'Pedidos de venta',
  deliveryNotes: 'Albaranes',
  invoices: 'Facturas',
  creditNotes: 'Abonos',
  allTransactions: 'Todas las operaciones',
  productsInventory: 'Artículos e inventario',
  productionProductDevelopment: 'Producción y desarrollo de producto',
  finance: 'Finanzas',
  bankAccounts: 'Cuentas bancarias',
  bankTransactions: 'Transacciones bancarias',
  bankReconciliation: 'Conciliación bancaria',
  payments: 'Asignaciones de pagos',
  openItems: 'Partidas abiertas',
  dunning: 'Gestión de cobros',
  communicationDocuments: 'Comunicación y documentos',
  marketing: 'Marketing',
  newsletterOverview: 'Resumen',
  newsletterCampaigns: 'Campañas',
  newsletterTemplates: 'Plantillas',
  newsletterAudiences: 'Audiencias',
  newsletterImports: 'Importación de destinatarios',
  newsletterRecipients: 'Destinatarios',
  newsletterConsents: 'Consentimientos',
  newsletterExistingCustomer: 'Revisión de cliente existente',
  newsletterSuppression: 'Lista de exclusión',
  newsletterDeliverability: 'Entregabilidad',
  newsletterAnalytics: 'Analítica',
  newsletterSettings: 'Ajustes',
  administration: 'Administración',
} as const;

export const navigationRu = {
  breadcrumb: 'Навигационная цепочка',
  crm: 'CRM',
  salesOrderProcessing: 'Продажи и обработка заказов',
  quotes: 'Коммерческие предложения',
  salesOrders: 'Заказы клиентов',
  deliveryNotes: 'Накладные',
  invoices: 'Счета',
  creditNotes: 'Кредит-ноты',
  allTransactions: 'Все операции',
  productsInventory: 'Товары и склад',
  productionProductDevelopment: 'Производство и разработка продукции',
  finance: 'Финансы',
  bankAccounts: 'Банковские счета',
  bankTransactions: 'Банковские операции',
  bankReconciliation: 'Банковская сверка',
  payments: 'Сопоставления платежей',
  openItems: 'Открытые позиции',
  dunning: 'Задолженность',
  communicationDocuments: 'Коммуникации и документы',
  marketing: 'Маркетинг',
  newsletterOverview: 'Обзор',
  newsletterCampaigns: 'Кампании',
  newsletterTemplates: 'Шаблоны',
  newsletterAudiences: 'Аудитории',
  newsletterImports: 'Импорт получателей',
  newsletterRecipients: 'Получатели',
  newsletterConsents: 'Согласия',
  newsletterExistingCustomer: 'Проверка постоянного клиента',
  newsletterSuppression: 'Список блокировок',
  newsletterDeliverability: 'Доставляемость',
  newsletterAnalytics: 'Аналитика',
  newsletterSettings: 'Настройки',
  administration: 'Администрирование',
} as const;
